import {fromJson} from '@github-ui/dotcom-schema/protobuf'
import {
  type RepoIssuesDashboardContentResponse,
  RepoIssuesDashboardContentResponseSchema,
} from '@github-ui/dotcom-schema/types/issues/v1/repo_issues_dashboard'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Query is a Relay-free utility subpath shared with the production saved-view renderer.
import {replaceDateTokens} from '@github-ui/list-view-items-issues-prs/Query'
import {queryFnFetchWithProtoSignal} from '@github-ui/react-core/future/query-fn-fetch'
import {queryOptions} from '@github-ui/react-query'

interface DataRouterResponse {
  payload?: Record<string, unknown>
}

export function savedViewIssuesQueryOptions({
  owner,
  repo,
  query,
  page,
}: {
  owner: string
  repo: string
  query: string
  page: number
}) {
  const resolvedQuery = replaceDateTokens(query)

  return queryOptions({
    queryKey: ['repo-saved-view-issues', owner, repo, resolvedQuery, page] as const,
    queryFn: async ({signal}) => {
      const {json, isProtoJson} = await queryFnFetchWithProtoSignal<DataRouterResponse>({
        routeId: 'issuesIndexContentRoute',
        queryName: 'savedViewIssues',
        queryDeps: {
          pathname: `/${owner}/${repo}/issues`,
          searchParams: {q: resolvedQuery, page: String(page)},
          init: {signal},
        },
      })
      const payload = json.payload?.issuesIndexContentRoute
      if (!payload) throw new Error('Unable to find the repository issues payload')
      return isProtoJson
        ? fromJson({
            schema: RepoIssuesDashboardContentResponseSchema,
            raw: payload,
            routeId: 'issuesIndexContentRoute',
            queryName: 'savedViewIssues',
          })
        : (payload as RepoIssuesDashboardContentResponse)
    },
  })
}
